import firebase from "../../firebase/firebaseConfig";
import { getStorage, ref, uploadBytesResumable, getDownloadURL } from "@firebase/storage";
import randomstring from 'randomstring'
import { getUTCTimeInMilliseconds } from "../helperFunctions";

export const uploadFileWithDetails = ({ fileData, fileId, folderPath, thumbData, onProgress, fileName, type }) => {
  const file = fileData?.localFile ?? fileData;

  return new Promise((resolve, reject) => {
    const storage = getStorage(firebase);
    const fileID = fileId ?? `user_doc_${randomstring.generate({ charset: 'alphanumeric', length: 16 })}`;

    const storageRef = ref(storage, `${folderPath}/${fileID}`);
    const extension = file.name.split(".").pop() || null;

    const uploadTask = uploadBytesResumable(storageRef, file);

    // Prepare thumbnail reference if thumbData is provided
    let thumbRef = null;
    let thumbUploadTask = null;
    if (thumbData) {
      thumbRef = ref(storage, `${folderPath}/thumbs/${fileID}_thumb`);
      thumbUploadTask = uploadBytesResumable(thumbRef, thumbData);
    }

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        if (onProgress) {
          const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          onProgress(progress);
        }
      },
      (error) => {
        console.error("Error uploading file:", error);
        reject(error);
      },
      async () => {
        try {
          const fileLink = await getDownloadURL(uploadTask.snapshot.ref);
          let thumbLink = '';
          let thumbPath = '';

          // Handle thumbnail upload if thumbData was provided
          if (thumbData && thumbRef && thumbUploadTask) {
            await thumbUploadTask;
            thumbLink = await getDownloadURL(thumbRef);
            thumbPath = `${folderPath}/thumbs/${fileID}_thumb`;
          }

          let fileDetails = {
            id: fileID,
            contentType: file.type,
            filePath: `${folderPath}/${fileID}.${extension}`,
            thumbPath: thumbPath,
            thumbLink: thumbLink,
            fileLink: fileLink,
            extension: extension,
            fileName: fileName ?? file.name,
            createdAt: getUTCTimeInMilliseconds(),
          };

          if (type) {
            fileDetails['type'] = type;
          }

          resolve(fileDetails);
        } catch (error) {
          console.error("Error getting download URL:", error);
          reject(error);
        }
      }
    );
  });
};